<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London</p>
<p class="copyright1">Copyright © 1998 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Seriatim : the Supreme Court before John Marshall / edited by Scott</p>
<p class="copyright">Douglas Gerber.</p>
<p class="copyright">p.  cm.</p>
<p class="copyright">Includes index.</p>
<p class="copyright">ISBN 0-8147-3114-7 (cloth : alk paper)</p>
<p class="copyright">1. United States. Supreme Court—History. 2. Judges—United</p>
<p class="copyright">States—Biography. 3. Judicial review—United States—History.</p>
<p class="copyright">4. Law and politics—History. I. Gerber, Scott Douglas, 1961-</p>
<p class="copyright">KF8742.S47 1998</p>
<p class="copyright">347.73’26—dc21              98-9056<br/>                                                CIP</p>
<p class="copyright1">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.</p>
<p class="copyrighta">Manufactured in the United States of America</p>
<p class="copyright1">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?21cc8528